/**
 * Marketing-site translator. Mirrors the widget's tiny translator (a pure
 * `t(key, params?)` over a resolved catalog) rather than reusing the dashboard's
 * `@syncanix/shared` `getCatalog` — that statically bundles all six dashboard
 * catalogs (1,600+ keys each), which would blow the marketing entry budget. The
 * marketing site ships only its own copy, with non-EN locales dynamically
 * imported (see `load-catalog.ts`).
 */
export type MarketingCatalog = Readonly<Record<string, string>>;

export type TranslationParams = Readonly<Record<string, string | number>>;

export type Translator = (key: string, params?: TranslationParams) => string;

const PARAM_PATTERN = /\{(\w+)\}/g;

function interpolate(template: string, params: TranslationParams | undefined): string {
  if (params === undefined) return template;
  return template.replace(PARAM_PATTERN, (match, name: string) =>
    Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match,
  );
}

/** Build a translator over a resolved catalog. Missing keys return the key. */
export function createTranslator(catalog: MarketingCatalog): Translator {
  return (key, params) => interpolate(catalog[key] ?? key, params);
}
